module.exports = __webpack_public_path__ + "static/media/randomNamePickerForeground.caae7198.svg";